/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PricingDto } from '../../models/pricing-dto';

export interface GetModelConceptPrice$Params {
  id?: string;
  authToken?: string;
}

export function getModelConceptPrice(http: HttpClient, rootUrl: string, params?: GetModelConceptPrice$Params, context?: HttpContext): Observable<StrictHttpResponse<PricingDto>> {
  const rb = new RequestBuilder(rootUrl, getModelConceptPrice.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
    rb.query('authToken', params.authToken, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PricingDto>;
    })
  );
}

getModelConceptPrice.PATH = '/api/pricing/modelConcept';
